import { Plus } from 'lucide-react';

import CardBlock from '@/components/CardBlock';
import { Button } from '@/components/ui/button';
import { DETAIL_MODE, DETAIL_TYPE, useDetailMode } from '@/hooks/useDetailMode';

const AppendixView = ({ document, setDocument }) => {
  const { mode } = useDetailMode(DETAIL_TYPE.DOCUMENT);

  const formData = document?.appendix?.formData || {};
  const rows = document?.appendix?.rows || [];

  const updateAppendix = (newPartial) => {
    setDocument((prev) => ({
      ...prev,
      appendix: {
        ...prev.appendix,
        ...newPartial,
      },
    }));
  };

  const handleAddTextClick = () => {
    const newSections = [
      ...rows,
      {
        id: +new Date(),
        type: 'textarea',
      },
    ];
    updateAppendix({ rows: newSections });
  };

  const handleAddFileClick = () => {
    const newSections = [
      ...rows,
      {
        id: +new Date(),
        type: 'file',
      },
    ];
    updateAppendix({ rows: newSections });
  };

  const handleAddTableClick = () => {
    const newSections = [
      ...rows,
      {
        id: +new Date(),
        type: 'table',
      },
    ];
    updateAppendix({ rows: newSections });
  };

  return (
    <>
      <div className="space-y-4">
        {rows.map(({ id, type }) => (
          <CardBlock
            formData={formData}
            id={id}
            key={id}
            mode={mode}
            sections={rows}
            setFormData={(updater) =>
              updateAppendix({ formData: updater(formData) })
            }
            setSections={(newSections) => updateAppendix({ rows: newSections })}
            titlePlaceholder={
              type === 'file'
                ? 'New File Entry'
                : type === 'table'
                  ? 'New Custom Table'
                  : undefined
            }
            type={type}
          />
        ))}
      </div>
      {mode !== DETAIL_MODE.STATIC && (
        <div className="flex gap-4 mt-4">
          <Button variant="outline" onClick={handleAddTextClick}>
            <Plus />
            Add Text Section
          </Button>
          <Button variant="outline" onClick={handleAddFileClick}>
            <Plus />
            Add File
          </Button>
          <Button variant="outline" onClick={handleAddTableClick}>
            <Plus />
            Add Custom Table
          </Button>
        </div>
      )}
    </>
  );
};

export default AppendixView;
